<ng-template #content>
  <div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button *ngIf="allowClose" type="button" class="close" aria-label="Close" (click)="handleClose($event)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ng-content></ng-content>
</ng-template>
